var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from "prop-types";

import moment from 'moment';
import "moment/locale/nb";
import "moment/locale/nn";
import "moment/locale/sv";

import { FormattedDate } from "react-intl";

var FormatDimension = (_temp2 = _class = function (_Component) {
    _inherits(FormatDimension, _Component);

    function FormatDimension() {
        var _temp, _this, _ret;

        _classCallCheck(this, FormatDimension);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderCompare = function () {
            var _this$props = _this.props,
                name = _this$props.name,
                value = _this$props.value;


            moment.locale('nb');

            var v1 = void 0,
                v2 = void 0;

            var isSameYear = moment(value[0]).isSame(value[1], 'year');
            var isSameMonth = moment(value[0]).isSame(value[1], 'month');
            var isSameDay = moment(value[0]).isSame(value[1], 'day');

            if (name == 'ga:nthYear') {
                v1 = moment(value[0]).format('YYYY');
                v2 = moment(value[1]).format('YYYY');
            }

            if (name == 'ga:nthMonth') {
                v1 = moment(value[0]).format('MMMM YYYY');
                v2 = moment(value[1]).format('MMMM YYYY');

                if (isSameYear) {
                    v1 = moment(value[0]).format('MMMM');
                    v2 = moment(value[1]).format('MMMM');
                }
            }

            if (name == 'ga:nthWeek') {
                v1 = moment(value[0]).format('Wo YYYY');
                v2 = moment(value[1]).format('Wo YYYY');
            }

            if (name == 'ga:nthDay') {
                v1 = moment(value[0]).format('ll');
                v2 = moment(value[1]).format('ll');

                if (isSameYear) {
                    v1 = v1.replace(moment(value[0]).format('YYYY'), '');
                    v2 = v2.replace(moment(value[0]).format('YYYY'), '');
                }

                if (isSameMonth) {
                    v1 = v1.replace(moment(value[0]).format('MMM'), '');
                }
            }

            if (name == 'ga:nthHour') {
                v1 = moment(value[0]).format('lll');
                v2 = moment(value[1]).format('lll');

                if (isSameYear) {
                    v1 = v1.replace(moment(value[0]).format('YYYY'), '');
                    v2 = v2.replace(moment(value[0]).format('YYYY'), '');
                }

                if (isSameDay) {
                    v2 = moment(value[1]).format('HH:mm');
                }
            }

            if (name == 'ga:nthMinute') {
                v1 = moment(value[0]).format('HH:mm');
                v2 = moment(value[1]).format('HH:mm');
            }

            return v1 + " vs. " + v2;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    FormatDimension.prototype.render = function render() {
        var _props = this.props,
            name = _props.name,
            value = _props.value;


        if (Array.isArray(value) && value.length === 2) {
            return this.renderCompare();
        }

        if (name == 'ga:nthYear') {
            return moment(value).format('YYYY');
        }

        if (name == 'ga:nthMonth') {
            return moment(value).format('MMMM');
        }

        if (name == 'ga:nthWeek') {

            var w1 = moment(value).startOf('week').format('DD. MMM');
            var w2 = moment(value).endOf("week").format('DD. MMM');

            return w1 + "–" + w2;

            //            return moment(value).format('Wo YYYY')
            //            return moment(value).format('Wo YYYY')
        }

        if (name == 'ga:nthDay') {
            return moment(value).format('LL');
        }

        if (name == 'ga:nthHour') {
            return moment(value).format('llll');
        }

        if (name == 'ga:nthMinute') {
            return moment(value).format('HH:mm');
        }

        return value;
    };

    return FormatDimension;
}(Component), _class.contextTypes = { intl: PropTypes.object }, _temp2);
FormatDimension.propTypes = process.env.NODE_ENV !== "production" ? {
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.array, PropTypes.string])
} : {};


export default FormatDimension;